<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview" v-if="initData">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">生产日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.md_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工单号</label>
            <span class="weui-form-preview__value">{{initData.md_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工单日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.md_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">制造类型</label>
            <span class="weui-form-preview__value">{{initData.md_type}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工作中心</label>
            <span class="weui-form-preview__value">{{initData.md_wcname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品编号</label>
            <span class="weui-form-preview__value">{{initData.main_pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品名称</label>
            <span class="weui-form-preview__value">{{initData.main_pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{initData.main_pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{initData.main_pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工单数量</label>
            <span class="weui-form-preview__value">{{initData.md_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工单行号</label>
            <span class="weui-form-preview__value">{{initData.dd_detno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单位用量</label>
            <span class="weui-form-preview__value">{{initData.dd_oneuseqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{initData.detail_pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{initData.detail_pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料型号</label>
            <span class="weui-form-preview__value">{{initData.detail_pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">可完工数量</label>
            <span class="weui-form-preview__value">{{initData.dd_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工时(时)</label>
            <span class="weui-form-preview__value">{{initData.mh_actworkhours}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">已领数</label>
            <span class="weui-form-preview__value">{{initData.md_havegetqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产出数量</label>
            <span class="weui-form-preview__value">{{initData.mh_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">QC检验数量</label>
            <span class="weui-form-preview__value">{{initData.qc_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不良品数量</label>
            <span class="weui-form-preview__value">{{initData.qc_ngqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不良率%</label>
            <span class="weui-form-preview__value">{{initData.qc_ngrate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">foqc待检数量</label>
            <span class="weui-form-preview__value">{{initData.foqc_djqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">foqc待入库数量</label>
            <span class="weui-form-preview__value">{{initData.foqc_dinqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">完工入库数量</label>
            <span class="weui-form-preview__value">{{initData.madeqty}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>